module.exports = __webpack_public_path__ + "static/lastgen-co2-intro-8b7d5553948305253d2bb8a8f83ab14a.webm";